export { useDynamicHeaderSubtitle } from './useDynamicHeaderSubtitle';
